import React from "react";
import { ConnectDeviceModalTemplate } from "themes/application/home/components";

function ConnectDeviceModal(props) {
    return <ConnectDeviceModalTemplate {...props} />;
}

export default ConnectDeviceModal;
